import { getParsedTrackingParams } from 'marketplace-ui-common/utils/trackingParams';
import { getMarketplaceEventProps } from 'marketplace-ui-tracking';
import { createContainer } from 'usage-tracker-multi';
const getSessionUrlParams = () => {
  const trackingParams = getParsedTrackingParams();
  return Object.keys(trackingParams).reduce((final, key) => {
    const value = trackingParams[key];
    final.push(`${key}=${value}`);
    return final;
  }, []);
};
let trackContainer;
export function createTracker({
  appContext,
  history
}) {
  if (!trackContainer) {
    trackContainer = createContainer({
      history
    });
  }
  return trackContainer.createTracker({
    standalone: true,
    trackerType: appContext === 'app' ? 'authed' : 'public',
    properties: getMarketplaceEventProps({
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public',
      // @ts-expect-error TODO: fix sessionUrlParams type
      sessionUrlParams: getSessionUrlParams()
    }),
    lastKnownEventProperties: ['screen']
  });
}